import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../locales/en/translation.json";
import tr from "../locales/tr/translation.json";
import ru from "../locales/ru/translation.json";
import de from "../locales/de/translation.json";
import fr from "../locales/fr/translation.json";
import es from "../locales/es/translation.json";

export const languages = [
  {
    name: "Türkçe",
    flag: "🇹🇷",
    code: "tr",
  },
  {
    name: "English",
    flag: "🇺🇸",
    code: "en",
  },
  {
    name: "Español",
    flag: "🇪🇸",
    code: "es",
  },
  {
    name: "Русский",
    flag: "🇷🇺",
    code: "ru",
  },
  {
    name: "Deutsch",
    flag: "🇩🇪",
    code: "de",
  },
  {
    name: "Français",
    flag: "🇫🇷",
    code: "fr",
  },
];

export const language = (() => {
  const langEnv =
    typeof process !== "undefined" && process.env.TEST_LANGUAGE
      ? process.env.TEST_LANGUAGE
      : "en";
  return languages.find((lang) => lang.code === langEnv)?.code;
})();

export const languageMap = {
  en: { messages: en, locale: "en" },
  tr: { messages: tr, locale: "tr" },
  es: { messages: es, locale: "es" },
  ru: { messages: ru, locale: "ru" },
  de: { messages: de, locale: "de" },
  fr: { messages: fr, locale: "fr" },
};

export const translation = languageMap[language as keyof typeof languageMap]
  .messages as typeof en;

const isTestEnv = process.env.NODE_ENV === "test";

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "tr",
    ...(isTestEnv
      ? {
          lng: language,
        }
      : {}),
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      es: { translation: es },
      ru: { translation: ru },
      de: { translation: de },
      fr: { translation: fr },
    },
  });

export default i18next;
